import { render, staticRenderFns } from "./ManagerHub.vue?vue&type=template&id=1ad8a6c4&scoped=true"
import script from "./ManagerHub.vue?vue&type=script&lang=js"
export * from "./ManagerHub.vue?vue&type=script&lang=js"
import style0 from "./ManagerHub.vue?vue&type=style&index=0&id=1ad8a6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad8a6c4",
  null
  
)

export default component.exports